import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineCommentEditIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="m21.71 4.72-2.43-2.43a.9999.9999 0 0 0-1.41 0l-5.58 5.58a1.0004 1.0004 0 0 0-.29.71v2.4201a1.0003 1.0003 0 0 0 1 1h2.42a1.0004 1.0004 0 0 0 .71-.29l5.58-5.58a.9998.9998 0 0 0 0-1.41ZM15 10.0002h-1v-1l4.58-4.58 1 1L15 10Zm4 2a.9997.9997 0 0 0-1 1 7 7 0 0 1-7 7H5.41l.64-.63a1.0003 1.0003 0 0 0 0-1.42A7 7 0 0 1 11 6.0001a1 1 0 1 0 0-2 9 9 0 0 0-7 14.62l-1.71 1.67a1 1 0 0 0-.21 1.09.9997.9997 0 0 0 .92.62h8a9.0004 9.0004 0 0 0 8.3149-5.5559A8.9995 8.9995 0 0 0 20 13.0001a.9997.9997 0 0 0-1-1Z"/>
  </SvgIcon>
}

export default LineCommentEditIcon
